export enum OrderProposalStatus {
  CREATED = 'created',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
}
